import { computeIconColor } from '@ardoq/dependency-map';
import type { GetComponentDisplayColorAsSVGAttributes } from '@ardoq/component-interface';

export const resolveIconColor = (
  componentId: string,
  getComponentDisplayColorAsSVGAttributes: GetComponentDisplayColorAsSVGAttributes
): string =>
  computeIconColor(
    getComponentDisplayColorAsSVGAttributes(componentId, {
      useAsBackgroundStyle: true,
    }).fill,
    getComponentDisplayColorAsSVGAttributes(componentId, {
      useAsBackgroundStyle: false,
    }).stroke
  );
